import clsx from "clsx";
import BlurredImage from "./BlurredImage";

type Props = {
  featureImage: string;
  title: string;
  description: string;
  isMobile?: boolean;
  containerClasses?: string;
  horizontal?: boolean;
  imageHash: string | null;
  textDark?: boolean;
};

export default function FeatureCard({
  featureImage,
  title,
  description,
  isMobile,
  containerClasses,
  horizontal,
  imageHash,
  textDark = false,
}: Props) {
  if (isMobile) {
    return (
      <div
        className={`grid grid-cols-12 gap-x-2 rounded border border-opacity-40 p-2 md:p-4 ${
          textDark ? "border-[#842572] text-primary" : "border-white text-white"
        }`}
      >
        <div className="col-span-3 h-full w-full lg:col-span-2">
          <img
            className="aspect-1 rounded border bg-gray-50 object-cover object-center"
            src={featureImage}
            alt={title}
          />
        </div>
        <div className="col-span-8 flex flex-col gap-y-1 font-satoshi">
          <p className="font-bold">{title}</p>
          <p className="break-words text-base">{description}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className={clsx(
        "min-h-full w-full rounded-xl border-1 border-slate-700 border-opacity-30 bg-white bg-opacity-5 p-3 hover:z-50",
        containerClasses,
      )}
    >
      <div className={clsx(horizontal && "flex gap-x-2 overflow-y-clip")}>
        <div className={clsx(horizontal ? "xl:h-20" : "xl:h-24", "flex aspect-1 h-16 rounded-2xl")}>
          <BlurredImage
            imageHash={imageHash}
            imageContainerClasses="h-full w-full rounded-xl border-2 border-white border-opacity-5 shadow-xl object-cover object-center"
            src={featureImage}
            alt={title}
          />
        </div>
        <div className={clsx(textDark ? "text-primary" : "text-white")}>
          <h3
            className={clsx(
              "cursor-default text-sm font-semibold first-letter:uppercase 2xl:text-lg",
              horizontal ? "" : "mt-2",
            )}
          >
            {title}
          </h3>
          <p
            title={description}
            className="transtion no-scrollbar line-clamp-2
        w-full cursor-default break-words pr-3 font-satoshi
          text-xxs font-450 leading-6 opacity-60
          2xl:text-xs "
          >
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}
